export default __webpack_public_path__ + "static/media/section3-pic5.5a41d62c.png";